import { defineSong } from '../types';

export default defineSong({
  id: 'sahil-yolu',
  title: 'Sahil Yolu',
  level: 1,
  key: 'G',
  bpm: 96,
  beats: 4,
  pattern: 'D-DU-UDU',
  style: 'Pop',
  desc: "Pop'un en sevilen dizisi I–V–vi–IV, {{pc:G}} majörde.",
  sections: [
    { name: 'Giriş', bars: ['G', 'D', 'Em', 'C'] },
    { name: 'Kıta', bars: ['G', 'D', 'Em', 'C', 'G', 'D', 'C', 'C'] },
    { name: 'Nakarat', bars: ['C', 'G', 'D', 'Em', 'C', 'G', 'D', 'D'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 5, text: 'Camlar:2 açık,:2 sahil:2 yolu:2' },
    { bar: 7, text: 'Rüzgâr:3 saçlarımda:5' },
    { bar: 9, text: 'Martılar:3 eşlik:2 ediyor:3' },
    { bar: 11, text: 'Radyoda:3 eski:2 bir:1 şarkı:2' },
    { bar: 13, text: 'Gel,:2 deniz:2 bizi:2 bekler:2' },
    { bar: 15, text: 'Güneş:2 batmadan:3 yetişelim:3' },
    { bar: 17, text: 'Bu:1 yol:1 bitmesin:4 hiç:2' },
    { bar: 19, text: 'Bu:1 yaz:1 bizim:2 olsun:4' },
  ],
});
